import React from "react";
import ProductDetails from "./productDetails";
import videoIcon from "../../assets/img/product-sliders/111.png"

const ProductSection = ({ title, listProducts, recived }) => {
  return (
    <section className="product_area" style={{margin: '100px 0'}}>
      <div style={{width: "90vw"}} className="mx-auto">
        <div className="row">
          <div className="col-12">
            <div className="section_title">
              <img src={videoIcon}/>
              <h2>{title}</h2>
            </div>
          </div>
        </div>
        <ProductDetails products={listProducts} recived={recived} />
      </div>
    </section>
  );
};

export default ProductSection;
